import { Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { SelectButton } from './select-button';

interface FilterOptionsProps<T extends string> {
  value: string;
  buttons: Array<{ value: T; label: ReactNode }>;
  setValue: (value: T) => void;
}

export function FilterOptions<T extends string>({
  buttons,
  value,
  setValue,
}: FilterOptionsProps<T>) {
  return (
    <Flex gap="8px" wrap="wrap">
      {buttons.map((button) => (
        <SelectButton
          key={button.value}
          value={button.value}
          actualValue={value}
          onClick={() => setValue(button.value)}
        >
          {button.label}
        </SelectButton>
      ))}
    </Flex>
  );
}
